var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pids-wrapper"},_vm._l((_vm.numberOfPids),function(n){return _c('div',{key:n,ref:"pid",refInFor:true,staticClass:"pid",class:{'-active': !!_vm.pids[n]}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }